export default __webpack_public_path__ + "static/media/Belt of the Faceless Sphinx.57010bef.jpg";